import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { capacityBalanceAtom } from '../../atoms';

import { Table, TableBody, TableCell, TableHead } from '@mui/material';

import { NumericTableCell } from 'components/shared/Table';
import TableHeaderRow from 'components/shared/Table/TableHeaderRow';

import { renderPeriodColumnHeaders } from '../../util';
import CollapsibleCapacityBalanceTableRow from './CollapsibleCapacityBalanceTableRow';
import { StyledTableContainer } from 'components/shared/Table/TableContainer.components';

const CapacityBalanceTable = () => {
  const { t } = useTranslation('common');
  const { isViewPerWeek } = useYearQuarterNavigation();
  const capacityBalance = useRecoilValue(capacityBalanceAtom);

  return (
    capacityBalance && (
      <StyledTableContainer>
        <Table stickyHeader size="small">
          <TableHead>
            <TableHeaderRow>
              <TableCell width={200} />
              {renderPeriodColumnHeaders(
                capacityBalance.periodHourBalances,
                isViewPerWeek
              )}
              <NumericTableCell width={68}>{t('yearTotal')}</NumericTableCell>
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {capacityBalance && (
              <CollapsibleCapacityBalanceTableRow
                capacityBalance={capacityBalance}
              />
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
    )
  );
};

export default CapacityBalanceTable;
